export const serviceUrls = [
  {
    name: 'Services',
    link: '/services',
  },
  {
    name: 'Packages',
    link: '/packages',
  },
  {
    name: 'Gifts',
    link: '/gift-card',
  },
  {
    name: 'Weddings',
    link: '/weddings',
  },
  {
    name: 'Events',
    link: '/events',
  },
  {
    name: 'Corporate Events',
    link: '/corporate-events',
  },
  {
    name: 'On-set Services',
    link: '/on-set',
  },
  {
    name: 'Group Glam',
    link: '/group-glam',
  },
]

export const supportUrls = [
  {
    name: 'FAQ',
    link: '/faq',
  },
  {
    name: 'Terms',
    link: '/terms',
  },
  {
    name: 'Privacy',
    link: '/privacypolicy',
  },
  {
    name: 'Community Guidelines',
    link: '/community-guidelines',
  }
]

export const aboutUrls = [
  {
    name: 'About Us',
    link: '/about-us',
  },
  {
    name: 'Become a Beauty Pro',
    href: 'https://apply.glamsquad.com',
  },
  {
    name: 'How It Works',
    link: '/how-it-works',
  },
  {
    // Mirrors the nav's marketing "Membership" link (WebNavBar/MobileNavBar) so the
    // footer has full parity with the nav — this entry was the only nav item missing.
    name: 'Membership',
    link: '/membership',
  },
  {
    name: 'Press',
    link: '/press',
  },
  {
    name: 'Ambassador Program',
    link: '/ambassadors',
  },
  {
    name: 'Blog',
    link: '/blog',
  }
]
